<template>
  <div class="dashboard-bookings-calendar-date">
    <span class="dashboard-bookings-calendar-date__number">{{ day.day }}</span>

    <div>
      <CalendarItem
        v-for="item in firstThreeItems"
        :key="item.key"
        :attributes="item"
      />
    </div>

    <template v-if="hasMoreBookings">
      <button
        type="button"
        class="dashboard-bookings-calendar-date__view-more"
        data-toggle="modal"
        :data-target="`#${id}`"
      >
        {{ moreCount }} meer
      </button>

      <div
        class="modal fade"
        :id="id"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Boekingen: {{ day.day }}-{{ day.month }}-{{ day.year }}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div :id="accordion">
                <AccordionItem
                  v-for="(item, index) in attributes"
                  :key="item.key"
                  :item="item"
                  :base-key="accordion"
                  :index="index"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CalendarItem from "./CalendarItem.vue";
import AccordionItem from "./AccordionItem.vue";

export default {
  name: "DashboardBookingsCalendarDate",
  components: { CalendarItem, AccordionItem },
  props: ["day", "attributes"],
  data() {
    return {
      currentIndex: 0,
      id: `modal-${this.day.day}-${this.day.month}`,
      accordion: `accordion-${this.day.day}-${this.day.month}`,
    };
  },
  computed: {
    firstThreeItems() {
      if (!this.attributes) {
        return [];
      }

      return Object.values(this.attributes).slice(0, 3);
    },
    moreCount() {
      return Math.max(0, (this.attributes?.length ?? 0) - 3);
    },
    hasMoreBookings() {
      return this.moreCount > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-bookings-calendar-date {
  &__number {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }

  &__view-more {
    font-size: 10px;
    color: rgba(0, 0, 0, 0.6);
    background-color: transparent;
    border: none;
    padding: 0;
  }
}
</style>
